import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-documentos-consulta',
  templateUrl: './documentos-consulta.component.html',
  styleUrls: ['./documentos-consulta.component.css']
})
export class DocumentosConsultaComponent implements OnInit {
  @Input() consulta: any = {};
  @Input() selectedView: string = '';        // video / consulta / paciente

  // 👇 el tab actual que viene del padre
  @Input() selectedTab: string = 'Anamnesis';

  @Output() selectedViewChange = new EventEmitter<string>();
  @Output() selectedTabChange = new EventEmitter<string>(); // puente hacia el padre

  ngOnInit(): void {}

  onSelectedTabChange(tabKey: string): void {
    // actualizar el tab que manejas aquí
    this.selectedTab = tabKey;
    // avisar al padre cuál es
    this.selectedTabChange.emit(tabKey);

    // si no estamos en "consulta", forzar el cambio de vista:
    if (this.selectedView !== 'consulta') {
      this.selectedView = 'consulta';
      this.selectedViewChange.emit('consulta');
    }
  }
}
